import React from 'react';
import { useLatestRef } from 'js/sign-components/common/use-latest-ref';
import HfReactHelper from 'js/sign-components/common/hf-react-helper';
import { MessageType, postTo } from 'js/sign-components/common/ts-message';


// https://developers.heap.io/reference#track
export type HeapProperties = Record<string | number, string | number | boolean | undefined>

declare global {
  interface Window {
    heap?: {
      track: (eventName: string, propertiesObj: HeapProperties) => void
    }
  }
}

type Subscription = (eventName: string, propertiesObj: HeapProperties) => void
const subscriptions: Array<Subscription> = [];

export function useHeapSubscription(subscription: Subscription) {
  const handlerRef = useLatestRef(subscription);
  React.useEffect(() => {
    const stableHandler: typeof handlerRef.current = (...args) => handlerRef.current(...args);
    subscriptions.push(stableHandler);

    return () => {
      const idx = subscriptions.indexOf(stableHandler);
      subscriptions.splice(idx, 1);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

export function RelayHeapEvents() {
  useHeapSubscription((eventName, properties) => {
    try {
      const postMessageUrl = window.parent.location.protocol + HfReactHelper.urlHelper('');
      postTo(window.parent, {
        type: MessageType.MobileHeapEvent,
        eventName,
        properties,
      }, postMessageUrl);
    } catch (_e) {
      // Accessing window.parent.location will throw if the parent is cross-origin.
    }
  });
  return null;
}

export function trackHeapCustomEvent(eventName: string, propertiesObj: HeapProperties = {}) {
  if ('heap' in window && window.heap) {
    window.heap.track(eventName, propertiesObj);
  }
  subscriptions.forEach((sub) => {
    try {
      sub(eventName, propertiesObj);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  });
}

export function useHeapCustomEvent(eventName: string) {
  React.useEffect(() => {
    trackHeapCustomEvent(eventName);
  }, [eventName]);
}
